import * as React from 'react';
import { DynamicPageProps } from '@doltech/routeDefinition';
import { WritingSampleTaskLanding } from '@doltech/modules/lib/practice-skills/landing/writings/WritingSampleTaskLanding';

interface LandingWritingSampleTaskTemplatePageProps extends DynamicPageProps {}

const LandingWritingSampleTaskTemplatePage = (props: LandingWritingSampleTaskTemplatePageProps) => {
  return <WritingSampleTaskLanding {...props} />;
};

export default LandingWritingSampleTaskTemplatePage;
